import { render, staticRenderFns } from "./OsobaRazdobljeEdit.vue?vue&type=template&id=732f05a0&scoped=true&"
import script from "./OsobaRazdobljeEdit.vue?vue&type=script&lang=js&"
export * from "./OsobaRazdobljeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732f05a0",
  null
  
)

export default component.exports